export default __webpack_public_path__ + "static/media/contact-2.b8db3c18.png";